import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from '/src/data/auto-generated/pagebuilder/lib/ContentTypes/Tabs/tabs.md';
import TabItem from '/src/data/auto-generated/pagebuilder/lib/ContentTypes/TabItem/tabItem.md';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "tabs-and-tabitem"
    }}>{`Tabs and TabItem`}</h1>
    <h2 {...{
      "id": "tabs"
    }}>{`Tabs`}</h2>
    {/*
     The reference doc content is generated automatically from the source code.
     To update this section, update the doc blocks in the source code
     */}

    <Tabs mdxType="Tabs" />
    <h2 {...{
      "id": "tabitem"
    }}>{`TabItem`}</h2>
    {/*
     The reference doc content is generated automatically from the source code.
     To update this section, update the doc blocks in the source code
     */}

    <TabItem mdxType="TabItem" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      